import React, { useState, useEffect, useRef } from 'react'
import { Menu } from '@material-ui/core'
import DataGrid from 'presentation/shared/components/DataGrid'
import {
  Column,
  Paging,
  Pager,
  LoadPanel,
  Editing
} from 'devextreme-react/data-grid'
import ScrollView from 'devextreme-react/scroll-view'
import {
  SurgicalPendencyStatus,
  SurgicalPendencyStatusTranslated
} from 'domain/entities/surgical-pendency'
import { LoadHealthInsurancePlans } from 'domain/usecases/health-insurance/load-health-insurance-plans'
import { LoadSurgeryCenter } from 'domain/usecases/surgery-center/load-surgery-center'
import { ReorderSurgicalOrder } from 'domain/usecases/surgical-order/reorder-surgery'
import { LoadSurgicalOrder } from 'domain/usecases/surgical-order/load-surgical-order'
import { LoadSurgicalOrderDocument } from 'domain/usecases/surgical-order/load-surgical-order-document'
import ButtonNew from 'presentation/shared/components/ButtonNew'
import UpdateSurgicalOrder from 'presentation/hospital/components/UpdateSurgicalOrder'
import { GuidesModal } from 'presentation/hospital/components/GuidesModal'
import TextFieldNew from 'presentation/shared/components/TextFieldNew'
import { SurgicalOrderModelNew } from 'domain/entities/surgical-order-model'
import moment from 'moment-timezone'
import { getShortName } from 'common/utils/getShortName'
import {
  SurgicalOrderSituation,
  SurgicalOrderSituationTranslated
} from 'common/enum/surgical-order-situation'
import { capitalizeText } from 'common/utils/capitalizeText'
import { useHistory } from 'react-router'
import { SurgicalOrderStatus } from 'common/enum/surgical-order-status'
import { ReactComponent as PendentIcon } from 'presentation/assets/icons/pendent-icon.svg'
import { ReactComponent as SearchIcon } from 'presentation/assets/icons/search.svg'
import { ReactComponent as PendencyIcon } from 'presentation/assets/icons/pendency-ok.svg'
import { ReactComponent as GuidesIcon } from 'presentation/assets/icons/article.svg'
import { ReactComponent as ResumIcon } from 'presentation/assets/icons/description.svg'
import { ReactComponent as FinishIcon } from 'presentation/assets/icons/update.svg'
import { ReactComponent as RemakeIcon } from 'presentation/assets/icons/renew.svg'
import { ReactComponent as ChangeStatusIcon } from 'presentation/assets/icons/change-status.svg'
import { ReactComponent as CancelSurgicalOrderIcon } from 'presentation/assets/icons/error.svg'
import { ReactComponent as DangerIcon } from 'presentation/assets/icons/alert-icon-new.svg'
import { ReactComponent as ElectiveIcon } from 'presentation/assets/icons/clock-rounded.svg'
import { ReactComponent as OtherSurgeriesIcon } from 'presentation/assets/icons/other-surgeries-icon.svg'
import { getStatusInfo } from 'presentation/utils/service-status'
import { getSurgicalOrderStatusEnumByLabel } from 'presentation/utils/surgical-order-status'
import { ServiceOverviewProps } from 'presentation/shared/components/ServiceOverview'
import { CancelSurgicalOrderModal } from 'presentation/hospital/components/CancelSurgicalOrderModal'
import { Patient } from 'domain/entities/patient-model'
import { SearchSurgicalOrdersModelNew } from 'service/usecases/search-surgical-orders/remote-search-surgical-orders-new'
import { SearchSurgicalOrdersNew } from 'domain/usecases/surgical-order/search-surgical-orders-new'
import { capitalizeEachWordText } from 'common/utils/capitalizeEachWordText'
import { getNameInitials } from 'common/utils/getNameInitials'
import normalizeText from 'common/utils/getNormalizedText'
import { TooltipNew } from 'presentation/shared/components/TooltipNew'
import * as S from './styles'
import { AuthorizationStatusTranslated } from 'common/enum/authorization-status'
import { ModalChangeStatus } from '../UpdateStatusModal'
import { ReactComponent as TriangleAlertIcon } from 'presentation/assets/icons/alert-triangle-filled.svg'
import { PasswordMaxDateValidationStatus } from 'common/enum/password-max-date-validation-status'
import { ReactComponent as IntegratedSurgicalOrderIcon } from 'presentation/assets/icons/integrated-surgical-order.svg'
import { ReactComponent as AuthRoboIcon } from 'presentation/assets/icons/auth-robo-icon.svg'
import { RemakeSurgicalOrder } from 'domain/usecases/surgical-order/remake-surgical-order'
import { SurgeryType, SurgeryTypeLocated } from 'common/enum/surgery-type'
import { ReactComponent as MedicalPrescritionIcon } from 'presentation/assets/icons/medical_prescrition.svg'
import { AuthorizedCommunicationStatus } from 'common/enum/authorized-communication-status'
import { useServices } from 'presentation/hooks/use-services'
import { toast } from 'react-toastify'
import {
  WithLoading,
  WithLoadingProps
} from 'presentation/shared/components/HOCs/WithLoading'
import SupportTextNew from 'presentation/shared/components/SupportTextNew'
import DividerNew from 'presentation/shared/components/DividerNew'

type Props = {
  data: SurgicalOrderModelNew[]
  filterInitialValues?: OldSurgicalOrderTableFormValues
  filterSubmit?: (
    fields?: SearchSurgicalOrdersNew.Params
  ) => Promise<SearchSurgicalOrdersModelNew | undefined>
  loadHealthInsurances?: LoadHealthInsurancePlans
  loadSurgeryCenters?: LoadSurgeryCenter
  reorderSurgicalOrder?: ReorderSurgicalOrder
  loadSurgicalOrder?: LoadSurgicalOrder
  loadSurgicalOrderDocument?: LoadSurgicalOrderDocument
  remakeSurgicalOrder?: RemakeSurgicalOrder
} & WithLoadingProps

const SurgicalOrderDataGrid = WithLoading(
  ({
    data,
    filterInitialValues,
    filterSubmit,
    loadHealthInsurances,
    loadSurgeryCenters,
    reorderSurgicalOrder,
    loadSurgicalOrder,
    loadSurgicalOrderDocument,
    remakeSurgicalOrder,
    setIsLoading
  }: Props) => {
    // const context = useAuthorizationContext()
    const history = useHistory()

    const dataGridRef = useRef<any>(null)
    const filtersRef = useRef<any>(null)
    const inputSearchPanelRef = useRef<any>(null)
    const allowedPageSizes = [5, 10, 15, 20, 30]
    const [activeOrder, setActiveOrder] = useState<SurgicalOrderModelNew>()

    const [otherSurgeries, setOtherSurgeries] = useState([]) as any
    const [showRemakeModal, setShowRemakeModal] = useState<boolean>(false)
    const [showChangeStatusModal, setShowChangeStatusModal] =
      useState<boolean>(false)
    const [showGuidesModal, setShowGuidesModal] = useState<boolean>(false)
    const [showCancelSurgicalOrder, setShowCancelSurgicalOrder] =
      useState<boolean>(false)
    const [anchorEl, setAnchorEl] = useState(null)

    const [anchorSurgeries, setAnchorSurgeries] = useState(null)
    const [surgery, setSurgery] = useState<ServiceOverviewProps>(
      {} as ServiceOverviewProps
    )

    const surgicalOrderService = useServices().surgicalOrder

    const handleClearFilters = (e: any) => {
      e.preventDefault()
      dataGridRef.current.instance.clearFilter()
      filtersRef.current.reset()
    }

    const isOrderedByPatientScreen =
      filterInitialValues?.status === SurgicalOrderStatus.ORDER_REGISTERED

    const handleSearchPanel = (e: any) => {
      e.preventDefault()
      const searchValue = inputSearchPanelRef.current.value

      if (isOrderedByPatientScreen) {
        dataGridRef.current.instance.filter(
          searchValue ? ['patient.name', 'contains', searchValue] : null
        )
        return
      }

      dataGridRef.current.instance.searchByText(searchValue)
    }

    const handleRowUpdated = async (changes: any) => {
      for (const change of changes) {
        const updatedRowKey = change
        try {
          setIsLoading(true)
          await surgicalOrderService.createOrUpdateBudget({
            surgical_order_id: updatedRowKey.key.surgical_order_id,
            value: updatedRowKey.data.budget
          })

          formattedData.map((item) => {
            if (
              item.surgical_order_id === updatedRowKey.key.surgical_order_id
            ) {
              item.budget = updatedRowKey.data.budget
            }
          })

          toast.success('Orçamento atualizado com sucesso')
        } catch (error) {
          toast.error('Erro ao atualizar o orçamento:')
        } finally {
          setIsLoading(false)
        }
      }
    }
    const menuActions = [
      {
        icon: ResumIcon,
        label: activeOrder?.is_solicitation
          ? 'Resumo da solicitação'
          : 'Resumo do pedido',
        handle: () => {
          handleClose()
          handleOpenActiveOrderReview()
        }
      },
      {
        icon: PendencyIcon,
        label: 'Pendência',
        handle: () => {
          handleClose()
          handlePendencyView()
        }
      },
      {
        icon: FinishIcon,
        label: 'Finalização do pedido',
        handle: () => {
          handleClose()
          handleOpenFinishOrderEdit()
        },
        integratedOnly: true
      },
      {
        icon: GuidesIcon,
        label: 'Gerar guias',
        handle: () => {
          handleClose()
          setShowGuidesModal(true)
        },
        integratedOnly: true
      },
      {
        icon: RemakeIcon,
        label: 'Refazer pedido',
        handle: () => {
          handleClose()
          setShowRemakeModal(true)
        },
        integratedOnly: true
      },
      {
        icon: ChangeStatusIcon,
        label: 'Mudar status',
        handle: () => {
          handleClose()
          setShowChangeStatusModal(true)
        },
        integratedOnly: true
      }
    ]

    const menuActionSolicitationCancel = [
      {
        icon: ResumIcon,
        label: activeOrder?.is_solicitation
          ? 'Resumo da solicitação'
          : 'Resumo do pedido',
        handle: () => {
          handleClose()
          handleOpenActiveOrderReview()
        }
      },
      {
        icon: PendencyIcon,
        label: 'Pendência',
        handle: () => {
          handleClose()
          handlePendencyView()
        }
      },
      {
        icon: FinishIcon,
        label: 'Finalizar pedido',
        handle: () => {
          handleClose()
          handleOpenFinishOrderEdit()
        },
        integratedOnly: true
      },
      {
        icon: GuidesIcon,
        label: 'Gerar guias',
        handle: () => {
          handleClose()
          setShowGuidesModal(true)
        },
        integratedOnly: true
      },
      {
        icon: RemakeIcon,
        label: 'Refazer pedido',
        handle: () => {
          handleClose()
          setShowRemakeModal(true)
        },
        integratedOnly: true
      },
      {
        icon: ChangeStatusIcon,
        label: 'Mudar status',
        handle: () => {
          handleClose()
          setShowChangeStatusModal(true)
        },
        integratedOnly: true
      },
      {
        icon: CancelSurgicalOrderIcon,
        label: 'Cancelar pedido',
        handle: () => {
          handleClose()
          handleCancelSurgicalOrder()
        },
        solicitationOnly: true
      }
    ]

    const menuActionSurgicalOrderCancelled = [
      {
        icon: ResumIcon,
        label: activeOrder?.is_solicitation
          ? 'Resumo da solicitação'
          : 'Resumo do pedido',
        handle: () => {
          handleClose()
          if (activeOrder?.is_solicitation) {
            history.push('/solicitacao/resumo', {
              id: activeOrder?.surgical_order_id
            })
          } else {
            history.push('/pedido-cancelado/resumo', {
              order: activeOrder
            })
          }
        }
      },
      {
        icon: GuidesIcon,
        label: 'Gerar guias',
        handle: () => {
          handleClose()
          setShowGuidesModal(true)
        },
        integratedOnly: true,
        solicitationOnly: false
      },
      {
        icon: RemakeIcon,
        label: 'Refazer pedido',
        handle: () => {
          handleClose()
          setShowRemakeModal(true)
        },
        integratedOnly: true
      }
    ]

    const handleOpenActiveOrderReview = () => {
      if (activeOrder?.is_solicitation) {
        history.push('/solicitacao/resumo', {
          id: activeOrder?.surgical_order_id
        })
      } else {
        history.push('/pedido/resumo', { id: activeOrder?.surgical_order_id })
      }
    }

    const handleCancelSurgicalOrder = () => {
      history.push('/pedido/solicitacao-cancelamento', {
        surgical_order_id: activeOrder?.surgical_order_id,
        patient_id: activeOrder?.patient?.patient_id
      })
    }

    const handlePendencyView = () => {
      // Authorized communication order:
      if (activeOrder?.authorized_communications?.length) {
        history.push('/pedido', {
          id: activeOrder.surgical_order_id,
          isAuthorizedCommunication: true
        })
      } else {
        history.push('/pedido/gerar-pendencia', {
          id: activeOrder?.surgical_order_id
        })
      }
    }

    const handleOpenFinishOrderEdit = () =>
      history.push('/pedido/finalizar', {
        id: activeOrder?.surgical_order_id,
        surgery
      })

    const handleRowClick = (event: any) => {
      const surgicalOrder: SurgicalOrderModelNew = event.data
      const status = surgicalOrder.active_status

      if (surgicalOrder.is_solicitation) {
        return
      }

      // const pendencies = surgicalOrder.pendencies?.length

      // Melhorar essas condições abaixo:
      if (status === 'Pedido aberto') {
        return
      }

      if (status === 'Cancelada') {
        // setActiveOrder(surgicalOrder)
        history.push('/pedido-cancelado/resumo', {
          order: surgicalOrder
        })
        // if (pendencies) {
        //   setActiveOrder(surgicalOrder)
        // } else {
        //   history.push('/pedido-cancelado/resumo', {
        //     order: surgicalOrder
        //   })
        // }
      } else {
        history.push('/pedido', {
          id: surgicalOrder.surgical_order_id,
          isSolicitation: status === 'Solicitação de cancelamento'
        })
      }
    }

    const handleMenuClick = (event: any, val: SurgicalOrderModelNew) => {
      setActiveOrder(val)
      setAnchorEl(event.currentTarget)
    }

    const handleMenuSurgeries = (event: any, val: any) => {
      setOtherSurgeries(val.item)
      setAnchorSurgeries(event.currentTarget)
    }

    const handleClose = () => {
      setAnchorEl(null)
    }

    const handleCloseSurgeries = () => {
      setAnchorSurgeries(null)
    }

    const filterSurgicalOrder = async () =>
      // pageNumber?: number,
      // pageSize?: number
      {
        // if (filterRef) {
        //   const orders = await filterSubmit?.({
        //     ...filterRef.current?.values,
        //     pagination: {
        //       pageNumber: pageNumber,
        //       pageSize: pageSize
        //     }
        //   })
        //   setPaginationState(orders?.pageInfo)
        // }

        filterSubmit && (await filterSubmit())
      }

    const MenuSurgeriesRender = (surgery: any) => {
      return (
        <OtherSurgeriesIcon
          width={20}
          height={20}
          onClick={(e) => {
            e.stopPropagation()
            handleMenuSurgeries(e, surgery)
          }}
        />
      )
    }

    const SurgicalOrderIDRender = (item: any) =>
      item?.value &&
      item?.data?.active_status !== 'Pedido aberto' && (
        <S.BoxDefault centered>{item.value}</S.BoxDefault>
      )

    const StatusRender = (item: any) =>
      item?.value && <S.StatusBadge>{item.value}</S.StatusBadge>

    const LeftTextRender = (item: any) =>
      item?.value && <S.BoxDefault>{item.value}</S.BoxDefault>

    const LeftWordBreakTextRender = (item: any) =>
      item?.value && <S.BoxDefault lineClamp>{item.value}</S.BoxDefault>

    // const CenteredTextRender = (item: any) =>
    //   item?.value && <S.BoxDefault centered>{item.value}</S.BoxDefault>

    // const CenteredWordBreakTextRender = (item: any) =>
    //   item?.value && (
    //     <S.BoxDefault centered lineClamp>
    //       {item.value}
    //     </S.BoxDefault>
    //   )

    const PatientTextRender = (item: any) =>
      item?.value && (
        <TooltipNew text={item?.value} type="standard" placement="bottom">
          <S.BoxDefault lineClamp>{item.value}</S.BoxDefault>
        </TooltipNew>
      )

    const ProcedureTextRender = (item: any) =>
      item?.value && (
        <TooltipNew text={item?.value} type="standard" placement="bottom">
          <S.BoxDefault lineClamp>{item.value}</S.BoxDefault>
        </TooltipNew>
      )

    const DoctorTextRender = (item: any) =>
      item?.value && (
        <TooltipNew text={item?.value} type="standard" placement="bottom">
          <S.BoxDefault lineClamp>{item.value}</S.BoxDefault>
        </TooltipNew>
      )

    const InteractionsStatusRender = (item: any) => {
      return (
        <S.BadgesWrapper>
          {item?.data?.iterations?.pendency?.status && (
            <S.InteractionsPendencyStatusBadge
              status={item?.data?.iterations?.pendency?.status}
            >
              {item?.data?.iterations?.pendency?.status ===
                SurgicalPendencyStatusTranslated.ANSWERED && (
                <span className="number">
                  {item?.data?.iterations?.pendency?.total}
                </span>
              )}
              <PendentIcon className="icon" />
            </S.InteractionsPendencyStatusBadge>
          )}
          {item?.data?.iterations?.authorized_communications?.length > 0 && (
            <TooltipNew
              text="Autorização comunicada por paciente"
              type="standard"
              placement="bottom"
            >
              <S.InteractionsAuthorizedCommunicationStatusBadge
                status={
                  item?.data?.iterations?.authorized_communications[0]?.status
                }
              >
                <MedicalPrescritionIcon className="icon" />
              </S.InteractionsAuthorizedCommunicationStatusBadge>
            </TooltipNew>
          )}
        </S.BadgesWrapper>
      )
    }

    const SituationStatusRender = (item: any) => {
      const OpmeGreenStatusTooltip = 'Até 11 dias desde sua criação'
      const NoOpmeGreenStatusTooltip = 'Até 7 dias desde sua criação'
      const OpmeOrangeStatusTooltip = 'Entre 12 e 14 dias desde sua criação'
      const NoOpmeOrangeStatusTooltip = 'Entre 8 e 9 dias desde sua criação'
      const OpmeRedStatusTooltip = 'Maior ou igual a 15 dias desde sua criação'
      const NoOpmeRedStatusTooltip =
        'Maior ou igual a 10 dias desde sua criação'

      const getTooltipText = () => {
        switch (item?.data?.situation?.status) {
          case SurgicalOrderSituation.GREEN:
            return item?.data?.opme === 'Sim'
              ? OpmeGreenStatusTooltip
              : NoOpmeGreenStatusTooltip

          case SurgicalOrderSituation.ORANGE:
            return item?.data?.opme === 'Sim'
              ? OpmeOrangeStatusTooltip
              : NoOpmeOrangeStatusTooltip

          case SurgicalOrderSituation.RED:
            return item?.data?.opme === 'Sim'
              ? OpmeRedStatusTooltip
              : NoOpmeRedStatusTooltip

          default:
            return ''
        }
      }
      return (
        <TooltipNew text={getTooltipText()} type="standard" placement="bottom">
          <S.SituationStatusBadge status={item?.data?.situation?.status}>
            {item?.text || ''}
          </S.SituationStatusBadge>
        </TooltipNew>
      )
    }

    function getFirstAndLastName(fullName: string) {
      const names = fullName?.trim().split(' ')

      if (names?.length > 2) {
        return `${names[0]} ${names[names?.length - 1]}`
      }

      return fullName
    }

    const handleOpenOrderDetails = (surgical_order_id: number) => {
      history.push('/pedido', {
        id: surgical_order_id
      })
    }

    const OtherSurgeriesContainer = (otherSurgeries: any) => {
      return (
        <div style={{ height: '310px', overflow: 'hidden' }}>
          <p style={{ padding: '10px 10px 0px' }}>
            <SupportTextNew
              color="neutral900"
              size="xsmall"
              weight="bold"
              style={{ marginBottom: '10px' }}
            >
              {otherSurgeries?.otherSurgeries?.length} cirurgias em aberto
            </SupportTextNew>
          </p>

          <ScrollView width="100%" height="100%">
            {otherSurgeries?.otherSurgeries?.length > 0 ? (
              <S.CardScroll>
                {otherSurgeries?.otherSurgeries?.map((item: any) => (
                  <>
                    <S.CardContainer
                      onClick={() =>
                        handleOpenOrderDetails(item.surgical_order_id)
                      }
                      key={item.surgical_order_id}
                    >
                      <SupportTextNew
                        weight="semiBold"
                        size="xsmall"
                        className="order"
                        color="neutral900"
                      >
                        Nº aviso: {item.surgical_order_id}
                      </SupportTextNew>
                      <SupportTextNew
                        weight="bold"
                        size="xsmall"
                        className="doctor"
                        color="neutral900"
                      >
                        Médico (a): {getFirstAndLastName(item.doctor.name)}
                      </SupportTextNew>
                      <SupportTextNew
                        weight="bold"
                        size="xsmall"
                        className="unit"
                        color="neutral900"
                      >
                        Unidade: {item.hospital.name}
                      </SupportTextNew>
                    </S.CardContainer>
                    <DividerNew marginBottom="0" marginTop="0" />
                  </>
                ))}
              </S.CardScroll>
            ) : (
              <p>Nenhum dado disponível</p>
            )}
          </ScrollView>
        </div>
      )
    }

    const InfoBadgesRender = (item: any) => {
      const today = moment().startOf('day')
      const expectedDate = moment
        .utc(item?.data?.scheduling_date[0]?.expected_date)
        .startOf('day')
      const remainingDays = expectedDate.diff(today, 'days')
      const renderRemainingDays = () => {
        if (remainingDays > 1)
          return `${remainingDays} dias até a ${
            item.value?.urgency ? 'urgência' : 'data prevista'
          }`
        if (remainingDays === 1)
          return `${remainingDays} dia até a ${
            item.value?.urgency ? 'urgência' : 'data prevista'
          }`
        if (remainingDays === 0)
          return `A ${
            item.value?.urgency ? 'data da urgência' : 'data prevista'
          } é hoje!`

        return `A ${
          item.value?.urgency ? 'data da urgência' : 'data prevista'
        } já passou!`
      }

      return (
        <S.BadgesWrapper>
          {/* MENU */}
          <S.DotsIcon
            width={24}
            height={24}
            onClick={(e) => {
              e.stopPropagation()
              handleMenuClick(e, item?.data)
            }}
          />

          {/* INT */}
          {item?.value?.patient_hospitalized && (
            <TooltipNew text="Internado" placement="bottom">
              <S.Badge color="white" bgColor="primary500">
                INT
              </S.Badge>
            </TooltipNew>
          )}

          {/* ROB */}
          {item?.value?.robotic && (
            <TooltipNew text="Robótica" placement="bottom">
              <S.Badge bgColor="secondary400">ROB</S.Badge>
            </TooltipNew>
          )}

          {/* ONCO */}
          {item?.value?.oncology_or_research && (
            <TooltipNew text="Oncológico" placement="bottom">
              <S.Badge bgColor="danger400">ONCO</S.Badge>
            </TooltipNew>
          )}

          {/* HEM */}
          {item?.value?.hemodinamica && (
            <TooltipNew text="Hedodinâmica" placement="bottom">
              <S.Badge bgColor="terciary300">HEM</S.Badge>
            </TooltipNew>
          )}

          {/* MAKO */}
          {item?.value?.makoRobot && (
            <TooltipNew text="Robô Mako" placement="bottom">
              <S.Badge bgColor="secondary400">MAKO</S.Badge>
            </TooltipNew>
          )}

          {/* ROSA */}
          {item?.value?.rosaRobot && (
            <TooltipNew text="Robô Rosa" placement="bottom">
              <S.Badge bgColor="secondary400">ROSA</S.Badge>
            </TooltipNew>
          )}

          {/* LASER */}
          {item?.value?.laser && (
            <TooltipNew text="Laser" placement="bottom">
              <S.Badge bgColor="secondary400">LASER</S.Badge>
            </TooltipNew>
          )}

          {/* ROBO AUTH */}
          {item?.value?.roboAuth && (
            <TooltipNew
              text="Autorização solicitada via automação"
              placement="bottom"
            >
              <AuthRoboIcon width={20} height={20} />
            </TooltipNew>
          )}

          {/* URGENCIA */}
          {item?.value.urgency && (
            <TooltipNew
              text={
                <>
                  <div>
                    Urgência
                    <br /> Data da urgência: {expectedDate.format('DD/MM/YYYY')}
                  </div>
                  <div>
                    <b>{renderRemainingDays()}</b>
                  </div>
                </>
              }
              placement="bottom"
            >
              <DangerIcon width={24} height={24} />
            </TooltipNew>
          )}

          {/* ELETIVO */}
          {item?.value.elective && (
            <TooltipNew
              text={
                <>
                  <div>
                    Pedido eletivo
                    <br /> Data prevista:{' '}
                    {!!expectedDate && expectedDate.isValid()
                      ? expectedDate.format('DD/MM/YYYY')
                      : 'Não preenchido'}
                  </div>
                  <div>
                    <b>
                      {!!expectedDate &&
                        expectedDate.isValid() &&
                        renderRemainingDays()}
                    </b>
                  </div>
                </>
              }
              placement="bottom"
            >
              <ElectiveIcon width={24} height={24} />
            </TooltipNew>
          )}

          {/* SENHA VENCIDA */}
          {item?.value?.expiredPassword && (
            <TooltipNew
              text={
                <>
                  <span>
                    Senha de autorização vencida
                    <br />
                    Validade:{' '}
                    {moment(
                      item?.data.finalize_surgical_order?.filter(
                        (obj: any) =>
                          obj?.is_active &&
                          obj?.password_max_date_validation_status ===
                            PasswordMaxDateValidationStatus.EXPIRED
                      )?.[0]?.password_max_date_validation
                    )
                      .utc()
                      .format('DD/MM/YYYY')}
                  </span>
                </>
              }
              type="standard"
              placement="bottom"
            >
              <S.TriangleAlertIconWrapper>
                <TriangleAlertIcon />
              </S.TriangleAlertIconWrapper>
            </TooltipNew>
          )}

          {/* PEDIDO INTEGRADO */}
          {item?.value?.isErpIntegration && (
            <TooltipNew
              text="Pedido Integrado"
              type="standard"
              placement="bottom"
            >
              <S.IntegratedSurgicalOrderIconWrapper>
                <IntegratedSurgicalOrderIcon />
              </S.IntegratedSurgicalOrderIconWrapper>
            </TooltipNew>
          )}

          {/* SURGERY TYPE */}
          {item?.value?.surgery_type && (
            <TooltipNew
              text={
                SurgeryTypeLocated[item?.value?.surgery_type as SurgeryType]
              }
              placement="bottom"
            >
              <S.Badge bgColor="info400">
                {SurgeryType[item?.value?.surgery_type as SurgeryType]}
              </S.Badge>
            </TooltipNew>
          )}

          {/* OTHER SURGERIES */}
          {item?.value?.other_surgeries?.length > 0 && (
            <S.Badge color="white" bgColor="transparent">
              <S.MenuSurgeriesWrapper>
                <MenuSurgeriesRender item={item.value.other_surgeries} />
              </S.MenuSurgeriesWrapper>
            </S.Badge>
          )}
        </S.BadgesWrapper>
      )
    }

    const CreatedByRender = (item: any) => {
      return (
        <S.CreatedByProfiles>
          {item?.value?.solicitation_name && (
            <TooltipNew
              text={item.value.solicitation_name}
              type="standard"
              placement="top"
            >
              <span className="profile">
                {getNameInitials(item.value.solicitation_name)}
              </span>
            </TooltipNew>
          )}
          {item?.value?.creation_name && (
            <TooltipNew
              text={item.value.creation_name}
              type="standard"
              placement="bottom"
            >
              <span className="profile">
                {getNameInitials(item.value.creation_name)}
              </span>
            </TooltipNew>
          )}
        </S.CreatedByProfiles>
      )
    }

    const LastInteractionRender = (item: any) => {
      if (!item?.value?.date) {
        return null
      }

      const relativeTime = moment.utc(item.value.date).locale('pt-br').fromNow()

      const formattedDate = moment
        .utc(item.value.date)
        .locale('pt-br')
        .format('DD/MM/YYYY [às] HH[h]mm')

      const tooltipText = `${item.value.name}\n${formattedDate}\n${relativeTime}`

      return (
        <TooltipNew text={tooltipText} type="standard" placement="bottom">
          <S.BoxDefault centered color="primary700">
            {relativeTime}
          </S.BoxDefault>
        </TooltipNew>
      )
    }

    const AuthorizationStatusRender = (item: any) => {
      const date = item?.data?.guide_details?.created_at
      const statusTranslated = item?.data?.guide_details?.status

      const dateFromNow = () => {
        const formattedDate = moment(date).utc().format('YYYY-MM-DD HH:mm:ss')
        return moment(formattedDate).fromNow()
      }

      return (
        statusTranslated && (
          <S.AuthorizationStatus>
            <S.CircleFill status={statusTranslated} />
            <div className="infos">
              <span className="status">{statusTranslated}</span>
              {date && <span className="date">{dateFromNow()}</span>}
            </div>
          </S.AuthorizationStatus>
        )
      )
    }

    const InfosBadgesHeaderFilter = [
      {
        text: 'Paciente internado',
        value: ['info_badges.patient_hospitalized', '=', true]
      },
      {
        text: 'Pedido com urgência',
        value: ['info_badges.urgency', '=', true]
      },
      {
        text: 'Pedido eletivo',
        value: ['info_badges.elective', '=', true]
      },
      {
        text: 'Pedido integrado',
        value: ['info_badges.isErpIntegration', '=', true]
      },
      {
        text: 'Robótica',
        value: ['info_badges.robotic', '=', true]
      },
      {
        text: 'Oncológico',
        value: ['info_badges.oncology_or_research', '=', true]
      },
      {
        text: 'Hemodinâmica',
        value: ['info_badges.hemodinamica', '=', true]
      },
      {
        text: 'Robô Mako',
        value: ['info_badges.makoRobot', '=', true]
      },
      {
        text: 'Robô Rosa',
        value: ['info_badges.rosaRobot', '=', true]
      },
      {
        text: 'Laser',
        value: ['info_badges.laser', '=', true]
      },
      {
        text: 'Senha vencida',
        value: ['info_badges.expiredPassword', '=', true]
      },
      {
        text: 'Autorização via Robô',
        value: ['info_badges.roboAuth', '=', true]
      }
    ]

    const InteractionsHeaderFilter = [
      {
        text: 'Pendência à resolver',
        value: [
          'iterations.pendency.status',
          '=',
          SurgicalPendencyStatusTranslated.ANSWERED
        ]
      },
      {
        text: 'Pendência em andamento',
        value: [
          'iterations.pendency.status',
          '=',
          SurgicalPendencyStatusTranslated.PENDENT
        ]
      },
      {
        text: 'Pendência resolvida',
        value: [
          'iterations.pendency.status',
          '=',
          SurgicalPendencyStatusTranslated.RESOLVED
        ]
      },
      {
        text: 'Comunicação autorizada à resolver',
        value: [
          'iterations.authorized_communications[0].status',
          '=',
          AuthorizedCommunicationStatus.PENDENT
        ]
      },
      {
        text: 'Comunicação autorizada em andamento',
        value: [
          'iterations.authorized_communications[0].status',
          '=',
          AuthorizedCommunicationStatus.IN_PROGRESS
        ]
      },
      {
        text: 'Comunicação autorizada resolvida',
        value: [
          'iterations.authorized_communications[0].status',
          '=',
          AuthorizedCommunicationStatus.RESOLVED
        ]
      }
    ]

    const formattedData = React.useMemo(() => {
      return data.map((item) => {
        const guideDetailsIsActive = item.guide_details?.find(
          (i: any) => i?.is_active
        )

        const hasRoboProvider = (item.guide_details ?? []).some(
          (i: any) =>
            typeof i?.provider === 'string' &&
            i?.provider.trim()?.toLowerCase() === 'laudo robo'
        )

        return {
          ...item,
          // TODO: Texto vem direto do backend, substituir por ENUM
          active_status:
            item.active_status === 'Aguardando retorno do convênio'
              ? 'No convênio'
              : item.active_status,
          patient: {
            ...item.patient,
            name: capitalizeEachWordText(item.patient!.name)
          },
          health_insurance: {
            ...item.health_insurance,
            name: capitalizeEachWordText(item.health_insurance!.name)
          },
          doctor: {
            ...item.doctor,
            name: capitalizeEachWordText(item.doctor!.name!)
          },
          main_procedure: capitalizeText(
            String(
              item.procedures?.find((i: any) => i.isMain)?.description ||
                SurgeryTypeLocated[item?.surgery_type as SurgeryType] ||
                ''
            )
          ),
          opme: item.opme ? 'Sim' : 'Não',
          budget: item.budget,
          iterations: {
            pendency: {
              status:
                SurgicalPendencyStatusTranslated[
                  item.iterations
                    ?.status as keyof typeof SurgicalPendencyStatusTranslated
                ],
              total: item.iterations?.total
            },
            authorized_communications: item?.authorized_communications
          },
          situation: {
            status: item.situation,
            text: SurgicalOrderSituationTranslated[
              item.situation as keyof typeof SurgicalOrderSituationTranslated
            ]
          },
          info_badges: {
            patient_hospitalized: item.patient_hospitalized,
            robotic:
              item.surgical_center === 'SALA ROBOTICA (C)' ? true : false,
            hemodinamica: normalizeText(item.surgical_center)
              ?.toLowerCase()
              .includes('hemodinamica')
              ? true
              : false,
            urgency: item.hospitalization_type === 'urgency' ? true : false,
            elective: item.hospitalization_type === 'elective' ? true : false,
            makoRobot:
              item.technique === 'makoRobot' || item.technique === 'robô mako'
                ? true
                : false,
            rosaRobot:
              item.technique === 'rosaRobot' || item.technique === 'robô rosa'
                ? true
                : false,
            laser: item.technique === 'laser' ? true : false,
            expiredPassword: item.finalize_surgical_order?.some(
              (i) =>
                i?.is_active &&
                i?.password_max_date_validation_status ===
                  PasswordMaxDateValidationStatus.EXPIRED
            ),
            isErpIntegration: item.is_erp_integration,
            oncology_or_research: item.oncology_or_research,
            surgery_type: item.surgery_type,
            other_surgeries: item.other_surgeries,
            roboAuth: hasRoboProvider
          },
          guide_details: {
            status: guideDetailsIsActive
              ? AuthorizationStatusTranslated[guideDetailsIsActive?.status]
              : undefined,
            created_at: guideDetailsIsActive
              ? guideDetailsIsActive?.created_at
              : undefined
          },
          created_at_formatted: moment(item.created_at)
            .utc()
            .format('DD/MM/YYYY [às] HH:mm[h]'),
          created_by: {
            solicitation_name: getShortName(item.solicited_by!),
            creation_name: getShortName(item.created_by!)
          },
          created_solicitation_canncel: moment(
            item.requested_cancellation?.props?.created_at
          )
            .utc()
            .format('DD/MM/YYYY [às] HH:mm[h]'),
          authorized_communication_created_at_formatted: moment(
            item?.authorized_communications?.[0]?.created_at
          )
            .utc()
            .format('DD/MM/YYYY [às] HH:mm[h]'),
          last_integration: {
            name: item.last_integration?.name
              ? getShortName(item.last_integration.name)
              : null,
            date: item.last_integration?.date || null
          },
          is_package: item.is_package ? 'Sim' : 'Não'
        }
      })
    }, [data])

    useEffect(() => {
      if (activeOrder) {
        const statusInfo = getStatusInfo(
          getSurgicalOrderStatusEnumByLabel(activeOrder.active_status || '')
        )

        const activeSurgery = {
          orderId: activeOrder.surgical_order_id,
          title: activeOrder?.main_procedure,
          status: activeOrder.active_status,
          unit: activeOrder?.hospital?.name,
          date: activeOrder?.created_at,
          doctorName: activeOrder.doctor?.name,
          patientName: activeOrder.patient?.name,
          color: statusInfo ? statusInfo.color : undefined,
          // patientEmail: activeOrder.patientEmail,
          // patientPhone: activeOrder.patientPhone,
          // doctorEmail: activeOrder.doctorEmail,
          // doctorPhone: activeOrder.doctorPhone,
          procedure: activeOrder?.main_procedure,
          type: 'Cirurgia'
        }
        setSurgery(activeSurgery)
      }
    }, [activeOrder])

    return (
      <S.Wrapper>
        <S.Filters ref={filtersRef} onSubmit={handleSearchPanel}>
          <div className="inputs">
            <TextFieldNew
              ref={inputSearchPanelRef}
              className="input-search-panel"
              placeholder={
                isOrderedByPatientScreen
                  ? 'Buscar por paciente'
                  : 'Buscar por paciente ou número do aviso'
              }
              iconPosition="insideLeft"
              icon={<SearchIcon />}
            />
          </div>
          <div className="actions">
            <ButtonNew type="submit" size="large" onClick={handleSearchPanel}>
              Buscar
            </ButtonNew>
            <ButtonNew type="button" size="large" onClick={handleClearFilters}>
              Limpar
            </ButtonNew>
          </div>
        </S.Filters>

        <DataGrid
          ref={dataGridRef}
          // keyExpr="surgical_order_id"
          dataSource={formattedData}
          onRowClick={handleRowClick}
          // columnAutoWidth={false}
          // scrolling={{
          //   mode: 'standard',
          //   useNative: false,
          //   showScrollbar: 'always'
          // }}
        >
          <Editing
            allowUpdating={true}
            mode="cell"
            onChangesChange={handleRowUpdated}
          />
          <Column
            caption=""
            dataField="info_badges"
            alignment="right"
            allowFiltering={true}
            allowEditing={false}
            allowSorting={false}
            headerFilter={{
              dataSource: InfosBadgesHeaderFilter,
              allowSearch: false
            }}
            cellRender={InfoBadgesRender}
          />

          <Column
            caption="Nº aviso"
            dataField="surgical_order_id"
            alignment="left"
            allowSearch={true}
            allowSorting={false}
            allowEditing={false}
            allowFiltering={false}
            allowHeaderFiltering={false}
            cellRender={SurgicalOrderIDRender}
            width={90}
          />
          <Column
            caption="Pacote"
            dataField="is_package"
            alignment="left"
            headerFilter={{
              allowSearch: false
            }}
            allowEditing={false}
            width={90}
          />
          <Column
            caption="Unidade"
            dataField="hospital.name"
            alignment="left"
            allowFiltering={false}
            allowEditing={false}
            allowSorting={false}
            headerFilter={{
              allowSearch: false
            }}
            width={120}
          />
          <Column
            caption="Status Pedido"
            dataField="active_status"
            alignment="left"
            name="active_status"
            allowFiltering={
              filterInitialValues?.status ===
              SurgicalOrderStatus.ORDER_REGISTERED
                ? false
                : true
            }
            allowEditing={false}
            headerFilter={{
              allowSearch: false,
              width: 300
            }}
            cellRender={StatusRender}
            width={170}
          />
          {/* Data criação surgical order: */}
          <Column
            caption="Dt. de criação"
            dataField="created_at_formatted"
            alignment="left"
            allowFiltering={false}
            allowSorting={false}
            allowEditing={false}
            cellRender={LeftTextRender}
            visible={!filterInitialValues!.with_authorized_communication}
            width={100}
          />
          <Column
            caption="Solic. criada em"
            dataField="created_solicitation_canncel"
            alignment="center"
            visible={[SurgicalOrderStatus.CANCELLATION_REQUEST].includes(
              filterInitialValues!.status!
            )}
            allowFiltering={false}
            allowSearch={false}
            allowEditing={false}
            headerFilter={{
              allowSearch: true,
              width: 450
            }}
            cellRender={LeftTextRender}
            width={110}
          />
          {/* Data criação authorized communication: */}
          <Column
            caption="Dt. de criação"
            dataField="authorized_communication_created_at_formatted"
            alignment="center"
            allowFiltering={false}
            allowSorting={false}
            allowEditing={false}
            cellRender={LeftTextRender}
            visible={!!filterInitialValues!.with_authorized_communication}
            width={110}
          />
          <Column
            caption="Paciente"
            dataField="patient.name"
            alignment="left"
            allowFiltering={false}
            allowEditing={false}
            allowSearch={true}
            cellRender={PatientTextRender}
            minWidth={160}
          />
          <Column
            caption="Convênio"
            dataField="health_insurance.name"
            alignment="left"
            // headerFilter={{
            //   allowSearch: false
            // }}
            cellRender={LeftWordBreakTextRender}
            width={120}
          />
          <Column
            caption="Cirurgia principal"
            dataField="main_procedure"
            alignment="left"
            allowFiltering={
              filterInitialValues?.status ===
              SurgicalOrderStatus.ORDER_REGISTERED
                ? false
                : true
            }
            allowEditing={false}
            headerFilter={{
              allowSearch: true,
              width: 450
            }}
            cellRender={ProcedureTextRender}
            minWidth={180}
          />
          <Column
            caption="Médico"
            dataField="doctor.name"
            alignment="left"
            allowEditing={false}
            allowFiltering={
              filterInitialValues?.status ===
              SurgicalOrderStatus.ORDER_REGISTERED
                ? false
                : true
            }
            cellRender={DoctorTextRender}
            minWidth={160}
          />
          <Column
            caption="OPME"
            dataField="opme"
            alignment="left"
            visible={
              filterInitialValues?.status ===
              SurgicalOrderStatus.ORDER_REGISTERED
                ? false
                : true
            }
            headerFilter={{
              allowSearch: false
            }}
            allowEditing={false}
            width={70}
          />
          <Column
            caption="Orçamento"
            dataField="budget"
            alignment="left"
            allowFiltering={true}
            allowEditing={true}
            editorOptions={{
              format: {
                type: 'currency',
                precision: 2,
                currency: 'BRL'
              },
              // showClearButton: true,
              useMaskBehavior: true
            }}
            cellRender={({ value }) =>
              `${Number(value)
                .toLocaleString('pt-BR', {
                  style: 'currency',
                  currency: 'BRL'
                })
                .replace('BRL', '')
                .trim()}`
            }
            visible={
              filterInitialValues?.status ===
              SurgicalOrderStatus.ORDER_REGISTERED
                ? false
                : true
            }
            width={105}
          />
          <Column
            caption="Pend."
            dataField="iterations"
            allowEditing={false}
            alignment="left"
            visible={
              filterInitialValues?.status ===
              SurgicalOrderStatus.ORDER_REGISTERED
                ? false
                : true
            }
            allowFiltering={true}
            allowSorting={false}
            headerFilter={{
              dataSource: InteractionsHeaderFilter,
              allowSearch: false,
              width: '360px'
            }}
            cellRender={InteractionsStatusRender}
            width={80}
          />
          <Column
            caption="Situação"
            dataField="situation.text"
            visible={
              filterInitialValues?.status ===
              SurgicalOrderStatus.ORDER_REGISTERED
                ? false
                : true
            }
            headerFilter={{
              allowSearch: false
            }}
            allowEditing={false}
            cellRender={SituationStatusRender}
            minWidth={80}
          />
          <Column
            caption="Aut. do convênio"
            dataField="guide_details.status"
            alignment="left"
            visible={[
              SurgicalOrderStatus.IN_HEALTH_INSURANCE,
              SurgicalOrderStatus.CRMO_VALIDATION
            ].includes(filterInitialValues!.status!)}
            allowEditing={false}
            allowSorting={false}
            headerFilter={{
              allowSearch: false
            }}
            cellRender={AuthorizationStatusRender}
          />
          <Column
            caption="Cri. por"
            dataField="created_by"
            alignment="center"
            allowEditing={false}
            allowFiltering={false}
            cellRender={CreatedByRender}
            width={70}
          />
          <Column
            caption="Ult. interação"
            dataField="last_integration"
            alignment="center"
            allowEditing={false}
            allowFiltering={false}
            allowSorting={false}
            cellRender={LastInteractionRender}
            width={120}
          />

          {/* Pagination */}
          <Paging enabled={true} defaultPageSize={20} defaultPageIndex={0} />
          <Pager
            visible={true}
            showPageSizeSelector={true}
            allowedPageSizes={allowedPageSizes}
            showNavigationButtons={true}
            showInfo={true}
            infoText="Página {0} de {1} ({2} itens)"
          />
          <LoadPanel enabled={false} />
        </DataGrid>

        <Menu
          style={{ marginLeft: '30px' }}
          anchorEl={anchorSurgeries}
          open={Boolean(anchorSurgeries)}
          onClose={handleCloseSurgeries}
        >
          <S.StyledSurgeryItem>
            <OtherSurgeriesContainer otherSurgeries={otherSurgeries} />
          </S.StyledSurgeryItem>
        </Menu>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
        >
          {activeOrder?.active_status === 'Cancelada'
            ? menuActionSurgicalOrderCancelled
                .filter(
                  (action) =>
                    !activeOrder?.is_solicitation || !action.integratedOnly
                )
                .map((action, index) => (
                  <S.StyledItem key={index} onClick={action.handle}>
                    <action.icon height={24} width={24} />
                    <span>{action.label}</span>
                  </S.StyledItem>
                ))
            : activeOrder?.active_status === 'Solicitação de cancelamento'
            ? menuActionSolicitationCancel
                .filter(
                  (action) =>
                    !activeOrder?.is_solicitation || !action.integratedOnly
                )
                .map((action, index) => (
                  <S.StyledItem key={index} onClick={action.handle}>
                    <action.icon height={24} width={24} />
                    <span>{action.label}</span>
                  </S.StyledItem>
                ))
            : menuActions &&
              menuActions
                .filter((action) => {
                  if (activeOrder?.active_status === 'Pedido aberto') {
                    return !action.integratedOnly
                  }

                  return action
                })
                .map((action, index) => (
                  <S.StyledItem key={index} onClick={action.handle}>
                    <action.icon height={24} width={24} />
                    <span>{action.label}</span>
                  </S.StyledItem>
                ))}
        </Menu>
        {showRemakeModal && (
          <UpdateSurgicalOrder
            surgicalOrderId={Number(activeOrder?.surgical_order_id)}
            loadHealthInsurance={loadHealthInsurances}
            loadSurgeryCenters={loadSurgeryCenters}
            close={() => setShowRemakeModal(false)}
            reorderSurgicalOrder={reorderSurgicalOrder}
            loadSurgicalOrder={loadSurgicalOrder}
            remakeSurgicalOrder={remakeSurgicalOrder}
          />
        )}
        {showGuidesModal && (
          <GuidesModal
            surgicalOrderId={Number(activeOrder?.surgical_order_id)}
            close={() => setShowGuidesModal(false)}
            loadSurgicalOrder={loadSurgicalOrder}
            loadSurgicalOrderDocument={loadSurgicalOrderDocument}
          />
        )}
        {showCancelSurgicalOrder && (
          <CancelSurgicalOrderModal
            close={() => setShowCancelSurgicalOrder(false)}
            patient={{ name: activeOrder?.patient?.name } as Patient}
            surgicalOrder={activeOrder}
            refreshTable={
              () => filterSurgicalOrder()
              // paginationState?.currentPage || 1,
              // paginationState?.itemsPerPage || 20
            }
          />
        )}
        {showChangeStatusModal && (
          <ModalChangeStatus
            surgicalOrderId={Number(activeOrder?.surgical_order_id)}
            activeStatus={activeOrder?.active_status}
            close={() => setShowChangeStatusModal(false)}
            filterSubmit={filterSurgicalOrder}
          />
        )}
      </S.Wrapper>
    )
  }
)

export default SurgicalOrderDataGrid

export type SurgicalOrderDataGridFormValues = {
  page_number?: number
  page_size?: number
  search: {
    status?: string
    start_date: string | Date
    end_date: string | Date
  }
}

export type OldSurgicalOrderTableFormValues = {
  surgical_order_id?: number
  start_date?: string
  end_date?: string
  surgical_pendency_status?: SurgicalPendencyStatus
  surgical_pendency_type?: string
  status?: SurgicalOrderStatus
  expired_passwords?: boolean
  with_authorized_communication?: boolean
  is_package?: boolean
}
